import { TableService } from './table-service';
import { Invoice } from '../../../models/invoice';
import { InvoiceQuery } from '../../../models/invoice-query';
import { Observable, of } from 'rxjs';
import { EntityEnum } from 'src/app/enum/entity.enum';
import { Sort } from '@angular/material/sort';
import {
    selectInvoiceTableBusy, selectInvoiceTableCount,
    selectInvoiceTablePage, selectInvoiceTableQuery,
    selectInvoiceTableSelection
} from '../../../store/invoice-table/invoice-table.state';
import { InvoiceColumnEnum } from 'src/app/enum/invoice-column.enum';
import {
    invoiceTableChangePage,
    invoiceTableMasterToggle,
    invoiceTableSort,
    invoiceTableToggle
} from '../../../store/invoice-table/invoice-table.actions';
import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class InvoiceTableService extends TableService<Invoice, InvoiceQuery> {

    protected getBusyObservable(): Observable<boolean> {
        return this.store.select(selectInvoiceTableBusy);
    }

    protected getColumnSelectionObservable(): Observable<string[]> {
        return of([
            'select',
            InvoiceColumnEnum.INVOICE_REFERENCE,
            InvoiceColumnEnum.INVOICE_DATE,
            InvoiceColumnEnum.INVOICE_TOTAL,
            'actions'
        ]);
    }

    protected getCurrentPageEntriesObservable(): Observable<Invoice[]> {
        return this.store.select(selectInvoiceTablePage);
    }

    protected getEntity(): EntityEnum {
        return EntityEnum.INVOICE;
    }

    protected getSelectionObservable(): Observable<string[]> {
        return this.store.select(selectInvoiceTableSelection);
    }

    protected getTableQueryObservable(): Observable<InvoiceQuery> {
        return this.store.select(selectInvoiceTableQuery);
    }

    protected getTotalCountObservable(): Observable<number> {
        return this.store.select(selectInvoiceTableCount);
    }

    pageChange(page: PageEvent): void {
        this.store.dispatch(invoiceTableChangePage({ pageNumber: page.pageIndex + 1, itemsPerPage: page.pageSize }));
    }

    sortChange(sort: Sort): void {
        this.store.dispatch(invoiceTableSort({ id: sort.active, descending: sort.direction === 'desc' }));
    }

    toggle(id: string): void {
        this.store.dispatch(invoiceTableToggle({ id }));
    }

    toggleAll(): void {
        this.store.dispatch(invoiceTableMasterToggle());
    }

}
